import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1186px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
